import React, { useState } from "react";
import styled from "styled-components";
import { Accordion } from "./components/setting-accordion";
import { Input } from "./components/input";
import { SaveButton } from "./components/save-button";
import iconSuccess from "../../../../../../images/iconNotificationSuccess.png";
import SettingIcon from "../../../../../../images/settings-icons/setting-password.png";
import { modifyUser } from "../../../../../../api";

const Row = styled.div`
  display: flex;
  align-items: flex-end;
  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-end;
  }
`;

const FieldsContainer = styled.div`
  width: 100%;
`;

const Spacer = styled.div`
  height: 8px;
`;

const Requirements = styled.div`
  p {
    display: flex;
	  align-items: center;
    @media(max-width: 900px) {
      margin-bottom: 2px
    }
  }
  img {
    width: 32px;
		margin-right: 4px;
  }
`;

const Bar = styled.div`
  background: #d5ddef;
  border-radius: 100px;
  height: 10px;
  max-width: 500px;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const BarFill = styled.div`
  border-radius: 100px;
  height: 10px;
  transition: 0.2s ease width;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background: #000;
  border-radius: 100px;
  margin: 12px 16px 12px 12px;
`;

const UpdatePassword = (props) => {
  const [show, setShow] = useState(false);
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [isLoading, setLoading] = useState(false);

  const isValidPassword = (password, passwordVerify) => {
    if (password !== passwordVerify) {
      props.openSnackbar("Passwords do not match.", true)
      return false;
    } else if (password.length < 8) {
      props.openSnackbar("Password must be at least 8 characters.", true)
      return false;
    } else if (!/(?=.*[a-z]+)/.test(password)) {
      props.openSnackbar("Password must have at least one uppercase and one lowercase letter.", true)
      return false;
    } else if (!/(?=.*[A-Z]+)/.test(password)) {
      props.openSnackbar("Password must have at least one uppercase and one lowercase letter.", true)
      return false;
    } else if (!/(?=.*\d+)/.test(password)) {
      props.openSnackbar("Password must have at least one number.", true)
      return false;
    }

    return true;
  };

  const getBarData = (password) => {
    let fillWidth = 100
    let color
    let text

    if (password.length < 8) fillWidth = fillWidth - 25;
    if (!/(?=.*[a-z]+)/.test(password)) fillWidth = fillWidth - 25;
    if (!/(?=.*[A-Z]+)/.test(password)) fillWidth = fillWidth - 25;
    if (!/(?=.*\d+)/.test(password)) fillWidth = fillWidth - 25;

    if (fillWidth <= 25 && fillWidth > 0) {
      color = "linear-gradient(#e32828, #ff3773)";
      text = "Password Strength - Very Weak"
    } else if (fillWidth > 25 && fillWidth <= 50) {
      color = "linear-gradient(#e39428, #ff7d37)";
      text = "Password Strength - Weak"
    } else if (fillWidth > 50 && fillWidth <= 75) {
      color = "linear-gradient(#c9e328, #eeff37)";
      text = "Password Strength - Good"
    } else if (fillWidth > 75) {
      color = "linear-gradient(#0e9e42, #00ee46)";
      text = "Password Strength - Great"
    }
    
    return {
      color: color,
      progress: fillWidth,
      text: text
    }
  }


  const handleSubmit = () => {
    let mods = {};
    mods["password"] = password;

    if (password !== verifyPassword) {
      props.openSnackbar("Passwords don’t match, try again.", true)
    }

    if (isValidPassword(password, verifyPassword)) {
      setLoading(true)
      modifyUser(props.userId, props.portalId, mods)
        .then((res) => {
          setLoading(false);
          props.loadPortalAccount();
          props.openSnackbar("Your password has been updated", false);
          setShow(false);
        })
        .catch((err) => {
          setLoading(false);
          props.openSnackbar("Unable to update password", true);
        });
    }
  };

  const handleReset = () => {
    setPassword('')
    setVerifyPassword('')
  }

  const disabled = password === "" || verifyPassword === "";

  const barData = getBarData(password);
  const passwordReq1 = (password.length < 8)
  const passwordReq2 = !(/(?=.*[a-z]+)/.test(password))
  const passwordReq3 = !(/(?=.*[A-Z]+)/.test(password))
  const passwordReq4 = !(/(?=.*\d+)/.test(password))
  return (
    <>
      <Accordion
        show={show}
        setShow={setShow}     
        handleReset={handleReset}       
        settingName="Password"
        description="Change account password"
        icon={SettingIcon}
        currentSetting={""}
        roundBottom
      >
        <Row>
          <FieldsContainer>
            <Input
              placeholder="New password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              type='password'
            />
            <Spacer />
            <Input
              placeholder="Confirm new password"
              onChange={(e) => setVerifyPassword(e.target.value)}
              value={verifyPassword}
              type='password'
            />
            <Spacer />
            <Bar>
              <BarFill style={{background: barData.color, width: `${barData.progress}%`}} />
            </Bar>
            <Spacer />
            {barData.text && <p style={{fontWeight: 'bold'}}>{barData.text}</p>}
            <Spacer />
            <Requirements>
              <p style={{marginBottom: '14px'}}>Your password should meet the following requirements:</p>
              <p>{passwordReq1 ? <Dot /> : <img src={iconSuccess} alt="icon" />} At least 8 characters</p>
              <p>{passwordReq2 ? <Dot /> : <img src={iconSuccess} alt="icon" />} At least one lowercase letter</p>
              <p>{passwordReq3 ? <Dot /> : <img src={iconSuccess} alt="icon" />} At least one uppercase letter</p>
              <p>{passwordReq4 ? <Dot /> : <img src={iconSuccess} alt="icon" />} At least one number</p>
            </Requirements>
          </FieldsContainer>
          <SaveButton
            isLoading={isLoading}
            disabled={disabled}
            onClick={handleSubmit}
          />
        </Row>
      </Accordion>
    </>
  );
};

export default UpdatePassword;
